<template>
  <div>
    <easyCruds ref="mainTable" :tableInfo="mainTable" @mainTableReload="mainTableReload" @resrt="resrt" @addRow="addRow"
      @editRow="editRow" @viewRow="viewRow" @deleteRows="deleteRows" @configRow="configRow">
    </easyCruds>

    <!-- 配置问卷 弹框 -->
    <el-dialog title="配置问卷" :visible.sync="configVisible" width="40%" append-to-body>
      <div class="pzwj">
        <h4>{{configData.wjtit}}</h4>
        <section class="sysm">
          <p>使用说明:</p>
          <p>1、您可以点击复制问卷按钮，然后选择希望复制的已存在的问卷，再对复制后的问卷进行编辑（不会影响被复制的问卷）。</p>
          <p>2、如果您已经编辑了问卷，点击复制问卷按钮会覆盖您之前的编辑，请谨慎操作。</p>
          <p>3、编辑问卷需要先选择题目类型，再点击新增按钮，即可打开编辑页面</p>
        </section>
        <div class="container">
          <div>
            <el-button @click="copyQues" type="danger" size="mini" :disabled="disabled">复制问卷</el-button>
          </div>
          <div>
            <span style="margin-right:20px">题目类型</span>
            <el-select v-model="configData.topicType" placeholder="请选择" size="small">
              <el-option v-for="item in configData.topicOptions" :key="item.value" :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <el-button @click="addQues" type="primary" size="mini" style="margin-left:20px"
              :disabled="disabled">新增问题</el-button>
          </div>
          <div class="topic">
            <ul v-if="configData.dxs.length">
              <li v-for="(dx,index) in configData.dxs" :key="index">
                <h5>题目名：{{dx.questionTitle}}</h5>
                <div v-for="(dxItem,i) in dx.data" :key="i" class="dxitem">
                  <el-radio v-model="dx.value" :label="i">{{dxItem.tit}}</el-radio>
                  <span>{{dxItem.score}}分</span>
                </div>
                <div class="caozuo">
                  <el-button type="primary" size="mini" @click="editQues(dx.id,index,'radio')"
                    :disabled="disabled">编辑</el-button>
                  <el-button type="danger" size="mini" @click="delQues(dx.type,index)"
                    :disabled="disabled">删除</el-button>
                </div>
              </li>
            </ul>
            <ul v-if="configData.checkboxs.length">
              <li v-for="(dx,index) in configData.checkboxs" :key="index">
                <h5>题目名：{{dx.questionTitle}}</h5>
                <div v-for="(dxItem,i) in dx.data" :key="i" class="dxitem">
                  <el-checkbox v-model="dxItem.checked">{{dxItem.tit}}</el-checkbox>
                  <span>{{dxItem.score}}分</span>
                </div>
                <div class="caozuo">
                  <el-button type="primary" size="mini" @click="editQues(dx.id,index,'checkboxs')"
                    :disabled="disabled">编辑</el-button>
                  <el-button type="danger" size="mini" @click="delQues(dx.type,index)"
                    :disabled="disabled">删除</el-button>
                </div>
              </li>
            </ul>
            <ul v-if="configData.jds.length">
              <li v-for="(jd,index) in configData.jds" :key="index">
                <h5>题目名：{{jd.questionTitle}}</h5>
                <div>
                  <el-input type="textarea" :rows="2" :placeholder="jd.bz" resize="none" v-model="jd.textarea">
                  </el-input>
                </div>
                <div class="caozuo">
                  <el-button type="primary" size="mini" @click="editQues(jd.id,index,'answer')"
                    :disabled="disabled">编辑</el-button>
                  <el-button type="danger" size="mini" @click="delQues(jd.type,index)"
                    :disabled="disabled">删除</el-button>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="configVisible = false">返 回</el-button>
        <el-button type="primary" @click="configConfirm" v-show="!disabled">保 存</el-button>
      </span>
    </el-dialog>

    <!-- 新增问题弹框 -->
    <el-dialog :title="addTit" :visible.sync="confAddVisible" width="30%" append-to-body>
      <div class="addQues">
        <el-form :model="addForm" ref="addForm" label-width="100px" :rules="rules">
          <el-form-item label="题目名" prop="tit">
            <el-input v-model="addForm.tit" placeholder="请输入题目名"></el-input>
          </el-form-item>
          <el-form-item label="题目排序" prop="sort">
            <el-input v-model="addForm.sort" placeholder="请输入题目排序"></el-input>
          </el-form-item>
          <el-form-item label="状态" prop="zt">
            <el-select v-model="addForm.zt" placeholder="请选择状态">
              <el-option label="禁用" value="0"></el-option>
              <el-option label="启用" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注" v-if="configData.topicType===3">
            <el-input type="textarea" v-model="addForm.bz" placeholder="请输入备注"></el-input>
          </el-form-item>
          <ul class="option" v-else>
            <li>
              <el-col :span="16">选项</el-col>
              <el-col :span="8">得分</el-col>
            </li>
            <li v-for="(item,index) in addOption" :key="index">
              <el-row :gutter="10">
                <el-col :span="16">
                  <el-input v-model="item.tit"></el-input>
                </el-col>
                <el-col :span="4">
                  <el-input v-model="item.score"></el-input>
                </el-col>
                <el-col :span="4">
                  <div class="btn">
                    <i class="el-icon-circle-plus" @click="optionPlus(index)"></i>
                    <i class="el-icon-remove" @click="optionReduce(index)"></i>
                  </div>
                </el-col>
              </el-row>
            </li>
          </ul>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="confAddVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveQues('addForm')">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 复制问卷弹框 -->
    <el-dialog title="复制问卷" :visible.sync="copy.copyVisible" width="70%" append-to-body>
      <easyCruds ref="copyTable" :tableInfo="copy.mainTable" @mainTableReload="copyTableReload"
        @copyConfirm="copyConfirm">
      </easyCruds>
      <!-- <span slot="footer" class="dialog-footer">
                <el-button @click="copy.copyVisible = false">取 消</el-button>
                <el-button type="primary" @click="copyConfirm">确 定</el-button>
            </span> -->
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      configVisible: false,
      confAddVisible: false,
      disabled: false,
      editIndex: null,
      edit: false,
      addTit: "新增",
      configData: {
        wjtit: "",
        wjid: "",
        topicType: null,
        topicOptions: [
          {
            value: 1,
            label: "单选"
          },
          {
            value: 2,
            label: "多选"
          },
          {
            value: 3,
            label: "填空、简答"
          }
        ],
        dxs: [],
        checkboxs: [],
        jds: []
      },
      addForm: {
        tit: "",
        sort: "",
        zt: "",
        bz: ""
      },
      rules: {
        tit: [{ required: true, message: "请输入题目名称", trigger: "blur" }],
        sort: [{ required: true, message: "请输入题目排序", trigger: "blur" }],
        zt: [{ required: true, message: "请选择状态", trigger: "change" }],
        opTit: [{ required: true, message: "请选择状态", trigger: "blur" }],
        score: [{ required: true, message: "请选择状态", trigger: "blur" }, { type: 'number', message: '分数只能为数字' }]
      },
      addOption: [
        {
          tit: "",
          score: ""
        }
      ],
      copy: {
        copyVisible: false,
        mainTable: {
          buttonSetting: {
            left: [
              {
                title: '确定复制',
                type: 'primary',
                clickEvent: 'copyConfirm',
              }
            ]
          },
          header: {
            title: "问卷列表"
          },
          table: {
            loading: false,
            height: 300,
            stripe: true,
            conditionLabelWidth: 'auto',
            selection: true,
            index: false,
            columns: [
              {
                prop: "wjmc",
                label: "问卷名称",
                isSearchCondition: true,
              },
              {
                prop: "xn",
                label: "学年",
                isSearchCondition: true,
                type: "select",
                required: true,
                dicData: []
              },
              {
                prop: "xq",
                label: "学期",
                isSearchCondition: true,
                type: "select",
                required: true,
                dicData: [
                  {
                    label: "第一学期",
                    value: "1"
                  },
                  {
                    label: "第二学期",
                    value: "2"
                  }
                ],
                dataFilter: function (value) {
                  if (value === "1") return "第一学期"
                  else return "第二学期"
                },
              },
              {
                prop: "createUserName",
                label: "创建人"
              },
              {
                prop: "createTime",
                label: "创建时间",
                view: [false, true, true],
                disabled: [true, true, true],
              },
              {
                prop: "state",
                label: "状态",
                isSearchCondition: true,
                type: "select",
                required: true,
                dicData: [
                  {
                    label: "禁用",
                    value: "0"
                  },
                  {
                    label: "启用",
                    value: "1"
                  }
                ],
                dataFilter: function (value) {
                  if (value === "1") return "启用"
                  else return "禁用"
                },
              }
            ],
            tableData: [],
            paging: {
              currentPage: 1,
              pageSizes: [10, 15, 20, 25],
              pageSize: 10,
              total: 0
            },
            reload: 'mainTableReload',
            reloadConditions: {},
            addDefultValue: {}
          }
        }
      },
      mainTable: {
        buttonSetting: {
          allowAdd: true,
          addFunctionName: 'addRow',
          addButtonArray: [{
            clickEvent: 'addRow',
            type: 'primary',
            buttonName: '新增',
            validate: true
          }],

          allowEdit: true,
          editFunctionName: 'addRow',
          editButtonArray: [{
            clickEvent: 'editRow',
            type: 'primary',
            buttonName: '保存编辑',
            validate: true
          }],

          allowDelete: true,
          deleteFunctionName: 'deleteRows',
          allowView: true,
          viewButtonArray: [{
            clickEvent: 'viewRow',
            type: 'primary',
            buttonName: '查看问卷配置',
            validate: false
          }]

        },
        header: {
          title: "问卷列表"
        },
        table: {
          loading: false,
          height: 550,
          stripe: true,
          conditionLabelWidth: 'auto',
          selection: true,
          index: false,
          columns: [
            {
              prop: "code",
              label: "问卷代码",
              disabled: [false, true, true],

            },
            {
              prop: "wjmc",
              label: "问卷名称",
              isSearchCondition: true,
              required: true,
              showWordLimit: true,
              maxlength: 30
            },
            {
              prop: "xn",
              label: "学年",
              isSearchCondition: true,
              type: "select",
              required: true,
              dicData: []
            },
            {
              prop: "xq",
              label: "学期",
              isSearchCondition: true,
              type: "select",
              required: true,
              dicData: [
                {
                  label: "第一学期",
                  value: "1"
                },
                {
                  label: "第二学期",
                  value: "2"
                }
              ],
              dataFilter: function (value) {
                if (value === "1") return "第一学期"
                else return "第二学期"
              },
            },
            {
              prop: "createUserName",
              label: "创建人",
              view: [false, true, true],
              disabled: [true, true, true],
            },
            {
              prop: "createTime",
              label: "创建时间",
              view: [false, true, true],
              disabled: [true, true, true],
            },
            {
              prop: "state",
              label: "状态",
              isSearchCondition: true,
              type: "select",
              required: true,
              dicData: [
                {
                  label: "禁用",
                  value: "0"
                },
                {
                  label: "启用",
                  value: "1"
                }
              ],
              dataFilter: function (value) {
                if (value === "1") return "启用"
                else return "禁用"
              },
            },
            {
              prop: "wjlx",
              label: "问卷类型",
              isSearchCondition: true,
              showInTable: false,
              type: "select",
              required: true,
              dicData: []
            },
            {
              prop: "wjms",
              label: "问卷描述",
              showInTable: false,
              type: "textarea",
              required: true,
              span: 24,
              showWordLimit: true,
              maxlength: 200
            }
          ],
          operation: {
            width: '220',
            operations: [
              {
                title: (params) => {
                  return "配置问卷"
                },
                clickEvent: 'configRow',
              }
            ]
          },
          tableData: [],
          paging: {
            currentPage: 1,
            pageSizes: [10, 15, 20, 25],
            pageSize: 10,
            total: 0
          },
          reload: 'mainTableReload',
          reloadConditions: {},
          addDefultValue: {}
        }
      }
    }
  },
  methods: {
    mainTableReload: function (params) {
      // console.log(params)
      this.mainTable.table.loading = true
      params = params || {}
      this.mainTable.table.loading = true
      if (!params.pageSize) { params.pageSize = 10 }
      if (!params.pageNum) { params.pageNum = 1 }
      this.$http.get('/wjInstall/query', {
        params
      }).then(
        response => {
          this.mainTable.table.loading = false
          if (response.code === 200) {
            // 成功之后的数据
            this.mainTable.table.tableData = response.data.records
            this.mainTable.table.paging.total = response.data.total || response.data.records.length
            return true
          } else {
            this.$message.error(response.msg)
          }
        }
      ).catch(
        error => {
          this.mainTable.table.loading = false
        }
      )
    },

    copyTableReload(params) {
      params.isInstall = "1";
      console.log(params);
      this.copy.mainTable.table.loading = true
      params = params || {}
      this.copy.mainTable.table.loading = true
      if (!params.pageSize) { params.pageSize = 10 }
      if (!params.pageNum) { params.pageNum = 1 }
      this.$http.get('/wjInstall/query', {
        params
      }).then(
        response => {
          this.copy.mainTable.table.loading = false
          if (response.code === 200) {
            // 成功之后的数据
            console.log(response);
            this.copy.mainTable.table.tableData = response.data.records
            this.copy.mainTable.table.paging.total = response.data.total || response.data.records.length
            return true
          } else {
            this.$message.error(response.msg)
          }
        }
      ).catch(
        error => {
          this.copy.mainTable.table.loading = false
        }
      )
    },


    // 新增
    addRow(row, done, errorDone) {
      this.$http.post("/wjInstall/save", null, { params: row }).then(res => {
        this.mainTableReload(this.$refs.mainTable.getReloadConditions())
        done();
      }).catch(error => {
        this.$message.error(error.msg);
        errorDone();
      })
    },

    // 编辑
    editRow: function (row, done, errorDone, optionType) {
      console.log(row);
      this.$http.put("/wjInstall/update", null, {
        params: {
          id: row.id,
          state: row.state,
          wjlx: row.wjlx,
          wjmc: row.wjmc,
          wjms: row.wjms,
          xn: row.xn,
          xq: row.xq,
          code: row.code
        }
      }).then(res => {
        this.mainTableReload(this.$refs.mainTable.getReloadConditions())
        done();

      }).catch(error => {
        this.$message.error(error.msg);
        errorDone();
      })

    },

    // 查看问卷配置
    viewRow(row, done, errorDone, optionType) {
      this.disabled = true;
      this.view(row);
      done();
    },

    // 打开配置问卷
    configRow(index, row) {
      this.disabled = false;
      this.view(row);
    },
    // 问题列表
    wt(data) {
      let dxsdata = [];
      let checkboxData = [];
      let jdsData = [];
      data.forEach(e => {
        let arr = [];
        let options = e.questionOption.split(",");
        let score = e.questionScore.split(",");
        // 单选
        if (e.questionType === 1) {
          console.log(1);
          for (let i = 0; i < options.length; i++) {
            let obj = {}
            obj.tit = options[i];
            obj.score = score[i];
            arr.push(obj);
          }
          dxsdata.push({
            questionTitle: e.questionTitle,
            value: "",
            data: arr,
            sort: e.questionSort,
            zt: e.status,
            id: e.id,
            type: e.questionType
          })
        }
        // 多选
        if (e.questionType === 2) {
          for (let i = 0; i < options.length; i++) {
            let obj = {}
            obj.tit = options[i];
            obj.score = score[i];
            obj.checked = false;
            arr.push(obj);
          }
          checkboxData.push({
            questionTitle: e.questionTitle,
            data: arr,
            sort: e.questionSort,
            zt: e.status,
            id: e.id,
            type: e.questionType

          })
        }
        // 简答、填空
        if (e.questionType === 3) {
          jdsData.push({
            questionTitle: e.questionTitle,
            textarea: "",
            bz: e.bz,
            sort: e.questionSort,
            zt: e.status,
            id: e.id,
            type: e.questionType

          })
        }

      })
      this.configData.dxs = dxsdata;
      this.configData.checkboxs = checkboxData;
      this.configData.jds = jdsData;
    },
    // 请求加载问题列表
    view(row) {
      this.configVisible = true;
      this.configData = this.$options.data().configData;
      this.configData.wjtit = row.wjmc;
      this.configData.wjid = row.id;
      this.$http.get("/wjTm/listByWjId", {
        params: {
          wjid: row.id
        }
      }).then(res => {
        // console.log(res);
        let data = res.data;
        this.wt(data);

      }).catch(error => {
        this.$message.error(error.msg);
      })
    },

    // 保存-问卷问题配置
    configConfirm() {
      let conf = this.configData;
      let questions = [];
      let func = (data, type) => {
        let conf = this.configData;
        if (conf[data].length > 0) {
          conf[data].forEach(e => {
            let questionOption = "";
            let questionScore = "";
            if (data !== "jds") {
              questionOption = e.data.map(e => {
                return e.tit
              }).join();
              questionScore = e.data.map(e => {
                return e.score
              }).join();
            }
            let obj = {};
            obj.wjid = conf.wjid,
              obj.questionType = type,
              obj.questionTitle = e.questionTitle,
              obj.questionOption = questionOption,
              obj.questionScore = questionScore,
              obj.questionSort = e.sort,
              obj.status = e.zt,
              obj.bz = data === "jds" ? e.bz : ""
            questions.push(obj)

          })
        }
      }
      func("dxs", 1);
      func("checkboxs", 2);
      func("jds", 3);

      if (!questions.length) {
        this.$message.error("问题不能为空");
        return;
      }

      console.log(questions)
      this.$http.post("/wjTm/saveForm",
        questions
      ).then(res => {
        this.configVisible = false;
        console.log(res);
      }).catch(error => {
        if (error.code === 13) {
          this.$message.error("配置问卷问题不能为空!")
        } else {
          this.$message.error(error.msg);
        }
      })
    },


    // 复制问卷
    copyQues() {
      this.copy.copyVisible = true;
      this.copyTableReload({});
    },
    // 确定复制
    copyConfirm() {
      let selectRow = this.$refs.copyTable.getSelectedRows();
      if (selectRow.length === 0) {
        this.$message.warning("请选中一条数据再进行操作")
      } else if (selectRow.length >= 2) {
        this.$message.warning("只能选择一条数据进行操作哟!")
      } else {
        this.$http.post("/wjTm/copyQuestionnaire", null, {
          params: {
            wjid: selectRow[0].id
          }
        }).then(res => {
          console.log(res)
          this.copy.copyVisible = false;
          let data = res.data;
          this.wt(data);

        }).catch(error => {
          this.$message.error(error.msg)
        })
      }

    },

    // 新增问题-弹框
    addQues() {
      if (this.configData.topicType) {
        this.addForm = this.$options.data().addForm;
        this.addOption = this.$options.data().addOption;
        this.confAddVisible = true;
        this.edit = false;
        this.addTit = "新增";

      } else {
        this.$message.warning("请先选择题目类型")
      }
    },
    // 新增问题-保存
    saveQues(addForm) {
      this.$refs[addForm].validate((valid) => {
        if (valid) {
          let index = this.edit ? this.editIndex : 0;
          let num = 0;
          num = this.edit ? 1 : 0;
          let saveflag = this.addOption.some(e => {
            return !e.tit || !e.score || !Number.isInteger(e.score * 1) || (e.score * 1 < 0)
          })
          // console.log(saveflag+'判断题目或分数是否为空,以及分数是否为正整数')
          if (!saveflag) {
            if (this.configData.topicType === 1)
              this.configData.dxs.splice(index, num, {
                questionTitle: this.addForm.tit,
                value: "",
                data: this.addOption,
                zt: this.addForm.zt,
                sort: this.addForm.sort,
                type: this.configData.topicType
              })
            if (this.configData.topicType === 2) {
              let data = [];
              this.addOption.forEach(e => {
                data.push({
                  tit: e.tit,
                  score: e.score,
                  checked: false
                })
              })
              this.configData.checkboxs.splice(index, num, {
                questionTitle: this.addForm.tit,
                data,
                zt: this.addForm.zt,
                sort: this.addForm.sort,
                type: this.configData.topicType
              })
            }
            if (this.configData.topicType === 3)
              this.configData.jds.splice(index, num, {
                questionTitle: this.addForm.tit,
                textarea: "",
                bz: this.addForm.bz,
                zt: this.addForm.zt,
                sort: this.addForm.sort,
                type: this.configData.topicType
              })
            this.confAddVisible = false;
          } else {
            this.$message.warning("选项或得分不能为空,并且得分为正整数!")
          }
        } else {
          return false;
        }
      });
    },

    // 编辑-问卷问题配置
    editQues(id, index, type) {
      this.editIndex = index;
      this.addTit = "编辑";
      this.confAddVisible = true;
      this.edit = true;
      console.log(id, index);
      if (id) {
        this.$http.get("/wjTm/get", {
          params: {
            id
          }
        }).then(res => {
          let data = res.data;
          this.configData.topicType = data.questionType;
          this.addForm.tit = data.questionTitle;
          this.addForm.sort = data.questionSort;
          this.addForm.zt = data.status + "";
          this.addForm.bz = data.bz;
          if (data.questionOption) {
            let tit = data.questionOption.split(",");
            let score = data.questionScore.split(",");
            let opdata = tit.map((e, i) => {
              return {
                tit: e,
                score: score[i],
              }
            })
            this.addOption = opdata;
          }
        }).catch(error => {
          this.$message.error(error.msg);
        })
      } else {
        this.addOption = this.$options.data().addOption;
        this.addForm = this.$options.data().addForm;
        let fun = (key) => {
          console.log(this.configData[key][index]);
          let data = this.configData[key][index];
          this.addOption = data.data;
          this.addForm.tit = data.questionTitle;
          this.addForm.sort = data.sort ? data.sort : "";
          this.addForm.zt = data.zt + "";
          this.addForm.bz = data.bz ? data.bz : "";
          this.configData.topicType = data.type;
        }
        if (type === 'radio') {
          fun("dxs");
        }
        if (type === 'checkboxs') {
          fun("checkboxs");
        }
        if (type === 'answer') {
          fun("jds");
        }
      }
    },

    // 删除问卷问题
    delQues(type, index) {
      // console.log(type,index);
      if (type === 1)
        this.configData.dxs.splice(index, 1)
      if (type === 2)
        this.configData.checkboxs.splice(index, 1)
      if (type === 3)
        this.configData.jds.splice(index, 1)
    },

    // 增加选项
    optionPlus(index) {
      this.addOption.splice(index + 1, 0, {
        tit: "",
        score: ""
      })
    },

    // 减少选项
    optionReduce(index) {
      if (this.addOption.length > 1) {
        this.addOption.splice(index, 1);
      }
    },

    // 删除
    deleteRows: function (deleteList) {
      // deleteList=deleteList.map(e=>{
      //     return e.id
      // }).join()
      // this.$http.delete('/wjInstall/delete',{
      //     params:{id:deleteList}
      // }).then(res=>{
      //     // console.log(res);
      //     this.mainTableReload(this.$refs.mainTable.getReloadConditions())
      //     this.$message.success('删除成功')
      // }).catch(error=>{
      //     this.$message.error(error.msg)
      // })


      deleteList.forEach(e => {
        if (e.state === "1") {
          this.$message.warning("已启用的问卷不可删除!")
        } else {

          this.$http.delete('/wjInstall/delete', {
            params: { id: e.id }
          }).then(res => {
            // console.log(res);
            this.$message.success('删除成功')
            this.mainTableReload(this.$refs.mainTable.getReloadConditions())
          }).catch(error => {
            this.$message.error(error.msg)
          })
        }
      })

    },

    // 排序
    sortBy: function (attr, rev) {
      //第二个参数没有传递 默认升序排列
      if (rev == undefined) {
        rev = 1;
      } else {
        rev = (rev) ? 1 : -1;
      }

      return function (a, b) {
        a = a[attr];
        b = b[attr];
        if (a < b) {
          return rev * -1;
        }
        if (a > b) {
          return rev * 1;
        }
        return 0;
      }
    },

    // 搜索下拉框
    getSelectDate(url, label, value, prop, params, method) {
      method = method || "post";
      params = { params } || {};
      let column = this.mainTable.table.columns;
      let index = this.findArray(column, prop, 'prop');
      let HTTP = method === "post" ? this.$http[method](url, null, params) : this.$http[method](url, params)
      HTTP.then(res => {
        // console.log(res);
        let arrDate = [];
        this.$nextTick(() => {
          res.data.forEach(element => {
            arrDate.push({
              label: element[label],
              value: element[value]
            })
          });
        })
        column[index].dicData = arrDate;
        // this.$refs.mainTable.setColumnSeting(prop, 'dicData', arrDate)

      }).catch(error => {
        this.$message.error(error.msg);
      })
    },


  },
  mounted() {
    this.mainTableReload({})
    // 问卷类型下拉框
    this.getSelectDate("/wjType/listSelect", "itemValue", "itemCode", "wjlx", { delFlag: 0 }, "get");

    // 学年下拉框
    this.$http.get("/Xn/queryMap").then(res => {
      let arrDate = [];
      let column = this.mainTable.table.columns;
      let column2 = this.copy.mainTable.table.columns;
      let index = this.findArray(column, "xn", 'prop');
      let index2 = this.findArray(column2, "xn", 'prop');

      res.data.forEach(element => {
        arrDate.push({
          label: element.xnd,
          value: element.id
        })
      });

      arrDate = arrDate.sort(this.sortBy('label', false));
      column[index].dicData = arrDate;
      column2[index2].dicData = arrDate;
      // this.$refs.mainTable.setColumnSeting('xn', 'dicData', arrDate)
      // this.$refs.copyTable.setColumnSeting('xn', 'dicData', arrDate)
    }).catch(error => {
      this.$message.error(error.msg);
    })


  },
}
</script>

<style lang="scss" scoped>
.pzwj {
  li {
    list-style: none;
  }
  h4 {
    font-size: 16px;
    text-align: center;
    margin: 0;
  }
  .sysm {
    color: red;
    p {
      margin: 0;
    }
  }
  .container {
    div:nth-child(1) {
      text-align: right;
    }
    div:nth-child(2) {
      margin-bottom: 10px;
    }
    .topic {
      ul {
        margin: 0;
        padding: 0;
        border: 1px solid #ccc;
        border-radius: 10px;
        margin-bottom: 20px;
        li {
          border-bottom: 1px solid #ccc;
          padding: 0 20px 20px;
          &:last-child {
            border: none;
          }
          h5 {
            font-size: 14px;
            font-weight: 400;
          }
          .dxitem {
            margin-top: 10px;
            width: 50%;
            span {
              float: right;
            }
          }
          .caozuo {
            margin-top: 20px;
          }
        }
      }
    }
  }
}
.addQues {
  .option {
    margin: 0;
    padding: 0;
    li {
      list-style: none;
      .btn {
        display: flex;
        align-items: center;
        text-align: center;
        height: 40px;
        i {
          flex: 1;
          &::before {
            font-size: 18px;
          }
        }
      }
    }
  }
}
</style>